module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon1.4ffe1cdb.png";